import { AutoMap } from '@automapper/classes';
import { IsArray, IsDefined, IsOptional, IsString, IsUUID } from 'class-validator';
import { AccountDto } from './account.model';

export class DeveloperDto {
  @AutoMap()
  @IsUUID()
  @IsDefined()
  id: string;

  @IsString()
  @IsDefined()
  displayLabel: string;

  @IsArray()
  @IsOptional()
  children?: AccountDto[];
}
